import { render, staticRenderFns } from "./selectPerson.vue?vue&type=template&id=7396038a&scoped=true&"
import script from "./selectPerson.vue?vue&type=script&lang=js&"
export * from "./selectPerson.vue?vue&type=script&lang=js&"
import style0 from "./selectPerson.vue?vue&type=style&index=0&id=7396038a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7396038a",
  null
  
)

export default component.exports